import { render } from "./shopping-gives-modal.vue?vue&type=template&id=229fbdde"
import script from "./shopping-gives-modal.vue?vue&type=script&lang=js"
export * from "./shopping-gives-modal.vue?vue&type=script&lang=js"

import "./shopping-gives-modal.vue?vue&type=style&index=0&id=229fbdde&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__